"use client"
/* */
import { isDynamicProp } from './isDynamicProp.mjs';
import { isFlowComponentProp } from '../isFlowComponentProp.mjs';

const resolveDynamicProps = (contextProps, localProps) => {
  const resolved = {};
  for (const prop in contextProps) {
    if (isFlowComponentProp(prop)) {
      const propValue = contextProps[prop];
      if (isDynamicProp(propValue)) {
        resolved[prop] = propValue.__dynamicProp(localProps);
      }
    }
  }
  return resolved;
};

export { resolveDynamicProps as default, resolveDynamicProps };
//# sourceMappingURL=resolveDynamicProps.mjs.map
